
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { TicketsModule } from '@/store/modules/tickets'
import { ORDERAPI } from '@/api/orders'
import { getuserCurrentApp } from '@/utils/cookies'

interface IFormdata {
  reason: string
}

const defaultRole: IFormdata = {
  reason: ''
}

@Component({
  name: 'RejectDialog'
})
export default class extends Vue {
  @Prop({ default: 0 }) private tid!: number
  @Prop({ default: 0 }) private ticketType!: number

  private rejectForm = Object.assign({}, defaultRole)
  private rules = {
    reason: [{ required: true, message: '请输入驳回原因', trigger: 'change' }],
  }
  private btnLoading = false

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get dialogVisible() {
    return TicketsModule.rejectDialog
  }

  get currentTicket() {
    return TicketsModule.currentTicket
  }

  @Watch('dialogVisible')
  private onDialogStatusChange(value: boolean) {
    if (value) { // 打开弹框
      this.rejectForm.reason = ''
      this.$nextTick(() => {
        if (this.$refs['rejectForm']) {
          (this.$refs['rejectForm'] as any).clearValidate()
        }
      })
    }
  }

  // 关闭弹框
  private handleClose() {
    TicketsModule.ToggleDialogStatus({
      name: 'rejectDialog',
      value: false
    })
  }

  // 驳回
  private handleSubmit() {
    const form: any = this.$refs['rejectForm']
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.btnLoading = true
        ORDERAPI.rejectTicket({
          tid: this.currentTicket.tid,
          t_type: this.currentTicket.ticket_type,
          solution: this.rejectForm.reason
        }, {
          app_id: this.userCurrentApp
        }).then((res: any) => {
          this.$emit('handleSuccess', res)
          this.btnLoading = false
          this.handleClose()
        }).catch(() => {
          this.btnLoading = false
        })
      } else {
        return false
      }
    })
  }
}
